
import React, { Component } from "react";
import style from "./style.scss";
import PropTypes from "prop-types";

export default class SideBarMenu extends Component {
    static propTypes = {
        menuItems: PropTypes.array
    }

    static defaultProps = {
        menuItems: []
    }

    render() {
        console.log(this.props.visible)
        return (
            <div className={style.sideBarMenu}>
                {this.props.menuItems.map((item, index) => (
                   <MenuItem key={index}
                        isSection={item.isSection || false}
                        title={item.title}
                        link={item.link || '#'}
                        icon={item.icon || null}
                        isNewTab= { item.isNewTab || false }
                        menuItems={item.menuItems || []} 
                        onClickToggleLeftSideBar={this.props.onClickToggleLeftSideBar}
                        visible={this.props.visible}
                        />
                ))}
            </div>
        )
    }
}

export class MenuItem extends Component {

    render() {
        return (
            <div className={[style.menuItem, this.props.isSection ? style.section : null].join(' ')} onClick={() => {
                if (this.props.menuItems.length <= 0 || !this.props.isSection) {
                    this.props.onClickToggleLeftSideBar();
                    if (this.props.isNewTab) {
                        window.open(this.props.link)
                    } else {
                        window.location.hash = this.props.link
                    }
                }

            }}>
                {this.props.isSection ? (<div className={style.sectionTitle}>{this.props.title}</div>) : (
                    this.props.title
                )}
                {this.props.menuItems.map((item, index) => (
                    <div style={{ display: item.visible?"block":"none"}}  key={'section-item-' + index} className={[style.menuItem, item.isSection ? style.section : null].join(' ')} onClick={(e) => {
                        this.props.onClickToggleLeftSideBar();
                        if (item.isNewTab) {
                            console.log(item.link)
                            window.open(item.link)
                        } else {
                            console.log(item)
                            window.location.hash = item.link
                        }

                    }}>
                        {item.icon != null ? (
                            <div className={style.itemIcon}>
                                {item.icon}
                            </div>
                        ) : null}

                        {item.title}
                    </div>
                ))}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Components/Theme/SideBarMenu/index.js